/**
 * Cafe Societe - Size Row Layout (STATIC approach)
 *
 * Creates "Tabela rozmiarów" link BEFORE <variant-selects>, placing it
 * OUTSIDE the AJAX blast zone. Dawn's Section Rendering API replaces
 * content INSIDE variant-selects on variant change — our element sits
 * before it as a sibling, so it's never destroyed. No MutationObserver,
 * no clone, no flicker.
 *
 * Uses a plain <button> with a manual click handler to open Dawn's
 * modal-dialog, because dynamically created <modal-opener> custom
 * elements don't auto-wire their click handlers.
 *
 * Runs on product pages only.
 */
(function () {
  'use strict';

  function initSizeRow() {
    // Already created? Don't duplicate.
    if (document.querySelector('.cs-size-row')) return false;

    // Find the variant container (this is what Dawn replaces on variant change)
    var variantContainer = document.querySelector('variant-selects, variant-radios');
    if (!variantContainer) return false;

    // Verify there's a size fieldset inside
    var fieldsets = variantContainer.querySelectorAll('fieldset');
    var hasSizeFieldset = false;
    for (var j = 0; j < fieldsets.length; j++) {
      var legend = fieldsets[j].querySelector('legend.form__label');
      if (legend && /^(size|rozmiar)$/i.test(legend.textContent.trim())) {
        hasSizeFieldset = true;
        break;
      }
    }
    if (!hasSizeFieldset) return false;

    // Find the modal ID from the original "Tabela rozmiarów" opener
    var openers = document.querySelectorAll('modal-opener.product-popup-modal__opener');
    var modalId = null;
    for (var i = 0; i < openers.length; i++) {
      var btn = openers[i].querySelector('.product-popup-modal__button');
      if (btn && /tabela\s+rozmiar/i.test(btn.textContent)) {
        modalId = openers[i].getAttribute('data-modal');
        break;
      }
    }
    if (!modalId) return false;

    // Create the static row
    var row = document.createElement('div');
    row.className = 'cs-size-row';

    // Create a plain button (NOT modal-opener — that doesn't auto-wire for dynamic elements)
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-popup-modal__button cs-size-row-btn';
    button.textContent = 'Tabela rozmiarów';

    // Manual click handler: open the Dawn modal-dialog directly
    button.addEventListener('click', function () {
      var modal = document.querySelector(modalId);
      if (modal) {
        // Dawn's ModalDialog has a show() method
        if (typeof modal.show === 'function') {
          modal.show(button);
        } else {
          // Fallback: toggle the open attribute
          modal.removeAttribute('hidden');
          modal.setAttribute('open', '');
          var overlay = modal.querySelector('.modal__close-button');
          // Focus the close button for accessibility
          if (overlay) overlay.focus();
        }
      }
    });

    row.appendChild(button);

    // Insert BEFORE variant-selects → outside AJAX blast zone → never destroyed
    variantContainer.parentNode.insertBefore(row, variantContainer);

    return true;
  }

  // Polling: wait for Dawn to render variant-selects
  var attempts = 0;
  function tryInit() {
    if (initSizeRow() || document.querySelector('.cs-size-row')) return;
    attempts++;
    if (attempts < 50) setTimeout(tryInit, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(tryInit, 50);
    });
  } else {
    setTimeout(tryInit, 50);
  }
})();
